import { useEffect, useId, useState } from 'react';
import { PillProps } from '../../Pill';
import { AppliedPill } from '../../AppliedFilters';
import { DataFilterType } from '../../DataFilters';

export type useTableFilterProps = {
    tableFilters: DataFilterType[];
    uniqueId?: string;
    onUpdate?: (props: { filters: DataFilterType[], appliedFilters?: PillProps[] }) => void,
}

export type useTableFilterReturnProps = {
    filters: DataFilterType[],
    onCancelAppliedFilter: (updated: AppliedPill[], d?: AppliedPill) => void,
    onClearAllAppliedFilter: () => void,
}

const useTableFilter = ({ tableFilters, uniqueId, onUpdate }: useTableFilterProps): useTableFilterReturnProps => {
    uniqueId = uniqueId ?? useId();

    const evaluate = (items: DataFilterType[]) => {
        return items.map((item, index) => {
            const { type, props } = item;

            if (type === 'Pill') {
                const iID = `filter-${uniqueId}-pill-${index}`;
                const cp = {
                    ...props,
                    id: props.id ?? iID,
                    active: (props as PillProps).active ?? false,
                    onSelect: (pill) => {
                        onClickPill(pill)
                    }
                } as PillProps;

                return {
                    type,
                    props: cp
                }
            }

            return item;
        });
    }

    const [filter, setFilters] = useState<DataFilterType[]>([]);

    const onClickPill = (pill: PillProps) => {
        setFilters(prev => {

            const fi = prev.map(item => {
                if (item.type === 'Pill') {
                    const { type, props } = item;
                    return {
                        type,
                        props: {
                            ...props,
                            active: props.id === pill.id ? !(props as PillProps).active : (props as PillProps).active
                        }
                    }
                }

                return item;
            })

            const appliedFilters = fi.reduce((prev, current): any => {
                if (current.type === 'Pill') {
                    const { props } = current as any;
                    if (props.active)
                        return [...prev, props]
                }
                return prev;
            }, []);

            onUpdate && onUpdate({ filters: fi, appliedFilters });
            return fi;
        });
    };

    const onCancelAppliedFilter = (appliedFilters: AppliedPill[], pill?: AppliedPill) => {
        setFilters(prev => {
            const fi = prev.map(item => {
                if (item.type === 'Pill') {
                    const { type, props } = item;
                    return {
                        type,
                        props: {
                            ...props,
                            active: props.id === pill?.id ? false : (props as PillProps).active
                        }
                    }
                }

                return item;
            })

            onUpdate && onUpdate({ filters: fi, appliedFilters });
            return fi;
        });
    }

    const onClearAllAppliedFilter = () => {
        setFilters(prev => {
            const fi = prev.map(item => {
                if (item.type === 'Pill') {
                    const { type, props } = item;
                    return {
                        type,
                        props: {
                            ...props,
                            active: false
                        }
                    }
                }

                return item;
            })

            onUpdate && onUpdate({ filters: fi, appliedFilters: [] });
            return fi;
        });
    }

    useEffect(() => {
        setFilters(evaluate(tableFilters));
    }, []);


    return {
        filters: filter,
        onCancelAppliedFilter,
        onClearAllAppliedFilter
    };
}

export default useTableFilter